import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../../context/notificationContext";
import { useI18n } from "../../../hooks/useTranslations";
import { useCostTypeCategoriesApi } from "../../../http/costTypeCategories/api";
import { UpsertCostTypeCategory } from "../../../http/costTypeCategories/types";
import SvgAdd from "../../icons/Add";
import Button from "../../ui/Button";
import ModalDialog from "../../ui/ModalDialog";
import CostTypeCategoryForm, { CostTypeCategoryFormBody } from "./CostTypeCategoryForm";

const CreateCostTypeCategoryButton: FC = () => {
  const i18n = useI18n();
  const [show, setShow] = useState(false);
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const costTypeCategoriesApi = useCostTypeCategoriesApi();

  const onSubmit = async (formData: CostTypeCategoryFormBody) => {
    const body: UpsertCostTypeCategory = {
      name: formData.name ?? "",
    };

    setIsSubmitting(true);
    try {
      await costTypeCategoriesApi.insertAdminCostTypeCategory(body);
      dispatch(showSuccessNotification(i18n.t));
      setShow(false);
    } catch (error) {
      dispatch(showErrorNotification(i18n, error));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Button buttonProps={{ onClick: () => setShow(true) }} glyph={SvgAdd} />
      {!!show && (
        <ModalDialog onClose={() => setShow(false)} title={i18n.t.costTypeCategories.new}>
          <CostTypeCategoryForm isDisabled={isSubmitting} onSubmit={onSubmit} />
        </ModalDialog>
      )}
    </>
  );
};

export default CreateCostTypeCategoryButton;
